module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/assessment_achievements/5_98f7f01dc4cdfb8cd624958397cbd271.png";